export const MODULE_NAME = 'map'

export const ADVERT_LAYER_ID = `advert_points`
export const POI_LAYER_ID = 'shop-detail-pois'

export const ACTIONS = {
}

export const GETTERS = {
}

export const MUTATIONS = {
  SET_VIEWSTATE: 'setViewState',
  CENTER_BBOX: 'centerBBox',
  RESET_VIEWSTATE: 'resetViewstate',
  FLY_TO: 'flyTo',
  ZOOM_IN: 'zoomIn',
  ZOOM_OUT: 'zoomOut'
}
